const config = {
  apiUrl: 'http://localhost:3000',
  insiderBuild: true,
  alternativeGameFlow: true,
};

export default config;
